import { render } from "./Princess.vue?vue&type=template&id=77f03eea&scoped=true"
import script from "./Princess.vue?vue&type=script&lang=js"
export * from "./Princess.vue?vue&type=script&lang=js"

import "./Princess.vue?vue&type=style&index=0&id=77f03eea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f03eea"]])

export default __exports__